import styled from "@emotion/styled";
import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export const PopupTitle = styled(DialogTitle)(({ theme }) => `
padding: 10px 16px;
text-align: center;
font-size: 16px;
@media (min-width: 600px){
  padding: 16px 24px;
  font-size: 18px;
  }
`);

export const DialogContentStyled = styled(DialogContent)(() => `
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`);

export const DescriptionStyled = styled.div`
max-width: 300px;
`;

export const WrapperActions = styled(DialogActions)`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
padding: 10px 16px;
min-width: 100%;
@media (min-width: 600px){
  padding: 16px 24px;
  }
`;

export const WrapperInfo = styled('div')(() => `
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
`);

export const NewInfo = styled('p')(({ theme }) => `
color: ${theme.palette.primary.main};
font-weight: 700;
`);

export const ButtonStyled = styled(Button)(({ theme, color }) => `
width: 100%;
margin-left: 0 !important;
`);

export const InfoFastQuiz = styled('p')(() => `
  font-size: 14px;
`); 